(function () {
  const gate = document.querySelector('[data-age-gate]:not([data-age-gate-initialized])');

  if (!gate) return;

  gate.dataset.ageGateInitialized = 'true';

  const storageKey = gate.dataset.ageGateStorageKey || 'althaiaAgeGateAccepted';
  const acceptedValue = 'true';
  const declineUrl = gate.dataset.ageGateDeclineUrl || 'https://www.google.com/';
  const panel = gate.querySelector('[data-age-gate-panel]');
  const checkbox = gate.querySelector('[data-age-gate-checkbox]');
  const acceptButton = gate.querySelector('[data-age-gate-accept]');
  const declineButton = gate.querySelector('[data-age-gate-decline]');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let previousActiveElement = null;

  function hasAccepted() {
    try {
      return window.localStorage.getItem(storageKey) === acceptedValue;
    } catch (error) {
      return document.cookie.split('; ').includes(`${storageKey}=${acceptedValue}`);
    }
  }

  function saveAccepted() {
    try {
      window.localStorage.setItem(storageKey, acceptedValue);
    } catch (error) {
      document.cookie = `${storageKey}=${acceptedValue}; path=/; max-age=31536000; SameSite=Lax`;
    }
  }

  function getFocusableElements() {
    return Array.from(gate.querySelectorAll(focusableSelector));
  }

  function openGate() {
    previousActiveElement = document.activeElement;
    gate.hidden = false;
    document.body.classList.add('age-gate-is-open');

    window.requestAnimationFrame(() => {
      if (checkbox) checkbox.focus();
      else if (panel) panel.focus();
    });
  }

  function closeGate() {
    saveAccepted();
    gate.hidden = true;
    document.body.classList.remove('age-gate-is-open');

    if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
      previousActiveElement.focus();
    }
  }

  if (hasAccepted()) return;

  openGate();

  checkbox?.addEventListener('change', () => {
    acceptButton.disabled = !checkbox.checked;
  });

  acceptButton?.addEventListener('click', () => {
    if (checkbox?.checked) closeGate();
  });

  declineButton?.addEventListener('click', () => {
    window.location.href = declineUrl;
  });

  gate.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!firstElement || !lastElement) {
      event.preventDefault();
      return;
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });
})();
